import { ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';
import Header from './Header';
import Footer from './Footer';
import { useI18n } from '../contexts/I18nContext';

export default function PageShell({ children, eyebrow, title, subtitle, accent = 'coral', heroImage, heroImageAlt = '' }) {
  const { t } = useI18n();
  const accentColor = accent === 'teal' ? '#5DCAB5' : accent === 'yellow' ? '#FCD968' : '#E5614C';

  return (
    <div className="min-h-screen bg-[#FAF3EE] flex flex-col">
      <Header />
      <main id="main-content" className="flex-1">
        {/* Page hero */}
        <section className="relative pt-[140px] pb-14 lg:pt-[180px] lg:pb-20 overflow-hidden">
          <div className="absolute -top-20 -left-20 w-[420px] h-[420px] rounded-full opacity-20 blur-3xl pointer-events-none" style={{ backgroundColor: accentColor }} />
          <div className="absolute -bottom-20 -right-20 w-[360px] h-[360px] rounded-full bg-[#5DCAB5]/20 blur-3xl pointer-events-none" />

          <div className="max-w-6xl mx-auto px-5 md:px-10 relative">
            <Link
              to="/"
              className="inline-flex items-center gap-1.5 text-[#E5614C] font-semibold text-sm hover:gap-2.5 transition-[gap]"
              data-testid="page-back-link"
            >
              <ArrowLeft className="h-4 w-4" /> {t('common.back')}
            </Link>

            {eyebrow && (
              <div className="block mt-10 lg:mt-14">
                <div
                  className="inline-flex items-center gap-2 font-semibold uppercase tracking-[0.2em] text-[12px]"
                  style={{ color: accentColor }}
                  data-testid="page-eyebrow"
                >
                  <span className="h-[2px] w-8" style={{ backgroundColor: accentColor }} /> {eyebrow}
                </div>
              </div>
            )}

            <h1 className="font-serif-display text-[44px] sm:text-[60px] lg:text-[76px] leading-[1.02] font-bold text-[#2A1B1A] mt-4 max-w-4xl">
              {title}
            </h1>
            {subtitle && (
              <p className="mt-6 text-[17px] lg:text-[19px] text-[#2A1B1A]/75 leading-relaxed max-w-2xl">
                {subtitle}
              </p>
            )}

            {heroImage && (
              <div className="mt-12 rounded-[28px] overflow-hidden shadow-[0_40px_80px_-30px_rgba(42,27,26,0.4)]">
                <img src={heroImage} alt={heroImageAlt} className="w-full h-[300px] sm:h-[420px] lg:h-[480px] object-cover" />
              </div>
            )}
          </div>
        </section>

        {children}
      </main>
      <Footer />
    </div>
  );
}
